import React, { Component } from "react";
import "../css/Register.css";
import headerImage from "../images/member-logo-white.svg";
import RegisterForm from "../components/RegisterForm";
import i18n from "i18next";
import getCookie from "../function/getCookie";
import { Translation } from "react-i18next";
import { Helmet } from "react-helmet";

class Register extends Component {
  state = {
    lang: "zhTW"
  };
  componentDidMount() {
    const lang =
      this.props.match.params.lang || getCookie("hk-emphasis-language"); //重整頁面先到cookie拿語系

    if (lang === "en") {
      i18n.changeLanguage("en");
      this.setState({
        lang: "en"
      });
      if (window.OneTrust) window.OneTrust.changeLanguage("en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      this.setState({
        lang: "zhTW"
      });
    }
  }
  render() {
    const pathname = window.parent.location.pathname;
    const { lang } = this.state;
    const description =
      lang === "en"
        ? "At EMPHASIS, we embrace different styles and looks, resonating with the tastes of women from all walks of life. Our original designs are more than pretty accessories. They are designed to complete your look and express your individuality. We live in a world that imposes expectations on beauty. Our logo, featuring the stylised outline of an unconventional crown, is a proud symbol of our mission to challenge these expectations and let your inner strength shine through. Crown the Beautiful You."
        : "EMPHASIS 的原創珠寶不僅精緻瑰麗，我們獨特多變的設計更能圓滿妳的妝容服飾，展露自我風格。妳我縱使身處受標準審美限制的大時代，但我們品牌標誌上象徵富棱角的后冠能賦予妳勇於衝破枷鎖的力量，讓妳盡情綻放自己的獨特個性，閃爍耀眼。冠冕女性之美。";

    return (
      <>
        <Helmet>
          <title>EMPHASIS</title>
          <meta name="description" content={description} />
          <link rel="canonical" href={window.location.href} />
        </Helmet>
        <div className="register-content" id="register-content">
          <div className="register-head">
            {pathname.includes("register") ? (
              <div
                className="mobile-register-close-button"
                onClick={() => {
                  window.close();
                }}
              ></div>
            ) : null}
            <img src={headerImage} alt="" />
          </div>
          <div className="register-body">
            <h3 className="register-subtitle">
              <Translation>{t => <>{t("registerPage.title")}</>}</Translation>
            </h3>
            <RegisterForm lang={this.state.lang} />
          </div>
        </div>
      </>
    );
  }
}

export default Register;
